import * as React from 'react';
import { Icon } from '../../Icon';
import { IIcon } from '../../../interfaces/IIcon';

export function DrinkIcon({ width, height, viewBox, style, className }: IIcon) {
    const newViewProps = '0 0 16 17' ?? viewBox;
    return (
        <Icon
            width={width}
            height={height}
            viewBox={newViewProps}
            style={style}
            className={className}
        >
            <g>
                <path d="M14.8715 4.00685C14.9518 3.90799 15 3.78114 15 3.64285C15 3.32742 14.7491 3.07142 14.44 3.07142H12.2378L13.0237 2.21257C13.0291 2.21257 13.0341 2.21428 13.04 2.21428C13.5037 2.21428 13.88 1.83057 13.88 1.35714C13.88 0.883714 13.5037 0.5 13.04 0.5C12.5763 0.5 12.2 0.883714 12.2 1.35714C12.2 1.38228 12.2053 1.40571 12.207 1.43028L10.7059 3.07142H1.56C1.25088 3.07142 1 3.32742 1 3.64285C1 3.78114 1.04816 3.90799 1.12852 4.00685L7.43999 12.1274V15.3571H5.47999C5.17087 15.3571 4.91999 15.6131 4.91999 15.9285C4.91999 16.244 5.17087 16.5 5.47999 16.5H10.52C10.8291 16.5 11.08 16.244 11.08 15.9285C11.08 15.6131 10.8291 15.3571 10.52 15.3571H8.55999V12.1274L14.8715 4.00685ZM2.75028 4.21428H9.66095L8.35447 5.64285H9.88607L11.1928 4.21428H13.25L12.0913 5.64285H9.88607H3.90892L2.75028 4.21428Z" />
            </g>
        </Icon>
    );
}
